import { projectEcho } from './projectEcho'
import { onEdgeEvent } from '../servers/commandStream'

/*
 * The push lane, module-scoped: a project "message" event from any machine goes
 * straight into that project's transcript. Same bridge the send echo uses, so
 * dedupe and (ts, cursor) ordering are already the hook's law. Registered once at
 * module load — the stream outlives any component, and so does this.
 *
 * Moved out of App.tsx in M7 (2026-09-03), verbatim: registering a global listener
 * as a side effect of importing the app shell was the census's example of why no
 * test has ever imported App.tsx. The side effect still exists — the stream must be
 * bridged whether or not anything rendered — but it is now a NAMED module a test can
 * mock, instead of an anonymous cost of touching the shell.
 */
onEdgeEvent((event, data) => {
  if (event === 'message' && typeof data['project_id'] === 'string') {
    projectEcho(String(data['project_id']), data)
  }
})
